import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from "underscore";
import { formatAmount } from '../../utils/string';
import { formatOpportunityCloseDate } from '../../utils/date';
import BaseModal from '../Modals/BaseModal';

// SASS Imports
require('./Modal.scss');
require('./OpportunityListModal.scss');

function mapStateToProps(state) {
    return {
        open: state.modal.isOpportunityListOpen,
        account: state.modal.opportunitiesFor
    };
}

class OpportunityListModal extends Component {
    constructor(props) {
        super(props);
    }

    _renderOpportunity(opportunity, key) {
        const closeDate = formatOpportunityCloseDate(opportunity.closeDate);
        const formattedAmount = formatAmount(opportunity.opportunityUsdAmount);

        return (
            <div key={"opportunity" + key} className="row opportunity">
                <h5>{opportunity.opportunityId}: {opportunity.opportunityName}</h5>
                <table>
                    <tbody>
                        <tr>
                            <th>Account manager</th>
                            <td>{opportunity.primaryAccountManager}</td>
                        </tr>
                        <tr>
                            <th>Stage</th>
                            <td>{opportunity.opportunityStage}</td>
                        </tr>
                        <tr>
                            <th>Deal type</th>
                            <td>{opportunity.dealType}</td>
                        </tr>
                        <tr>
                            <th>Close date</th>
                            <td>{closeDate}</td>
                        </tr>
                        <tr>
                            <th>Amount</th>
                            <td>${formattedAmount} USD</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const account = this.props.account;
        let sortedOpportunities = _.sortBy(
            account.opportunities,
            "opportunityName"
        );
        let description = account.accountName;

        if (account.company) {
            description += ` (${account.company.standardCompanyName})`;
        }

        return (
            <BaseModal
                isOpen={this.props.open}
                hasCloseButton={true}
                renderWithHeader={true}
                title="Opportunities"
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => this.props.closeModal()}
                containerClass="opportunity-list-modal"
            >
                <div className="opportunity-modal">
                    <div className="row opportunities-label">
                        <div className="col-xs-12">
                            <h4>
                                Opportunities for <em>{description}</em>
                            </h4>
                        </div>
                    </div>
                    <div className="col-xs-12 opportunities-list">
                        {sortedOpportunities.map(
                            (opportunity, i) => this._renderOpportunity(
                                opportunity,
                                i
                            )
                        )}
                    </div>
                </div>
            </BaseModal>
        );
    }
}

export default connect(mapStateToProps)(OpportunityListModal);



// WEBPACK FOOTER //
// ./app/components/Modals/OpportunityListModal.jsx